export const RELIABILITY = [
  {
    label: 'Alta',
    value: 0.9,
  },
  {
    label: 'Media',
    value: 0.5,
  },
  {
    label: 'Baja',
    value: 0.1,
  },
];
